module.exports = __webpack_public_path__ + "static/media/Burger_Shop.62402bf9.png";